import {Construtor} from './construtor';

export class IndicadorRotina implements Construtor<IndicadorRotina> {

  public idIndicadorRotina: number;
  public idIndicador: number;
  public idRotinaProcesso: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (IndicadorRotina)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdIndicadorRotina(idIndicadorRotina: any) {
    this.idIndicadorRotina = idIndicadorRotina;
  }

  set IdRotinaProcesso(idRotinaProcesso: any) {
    this.idRotinaProcesso = idRotinaProcesso;
  }

  set IdIndicador(idIndicador: any) {
    this.idIndicador = idIndicador;
  }

  parseFromJson(indicadorRotina: any): void {
    this.idIndicadorRotina = indicadorRotina.idIndicadorRotina;
    this.idRotinaProcesso = indicadorRotina.idRotinaProcesso;
    this.idIndicador = indicadorRotina.idIndicador;
  }

  copyObject(indicadorRotina: IndicadorRotina): void {
    this.idIndicadorRotina = indicadorRotina.idIndicadorRotina;
    this.idRotinaProcesso = indicadorRotina.idRotinaProcesso;
    this.idIndicador = indicadorRotina.idIndicador;
  }

  modeloCompleto(): boolean {
    return this.idRotinaProcesso !== undefined && this.idIndicador !== undefined;
  }

  getNewInstance(object?: any): IndicadorRotina {
    return new IndicadorRotina(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/indicador-rotina.ts